<template>
  <div>
    <div v-if="this.contractor.active === true && this.contractor.invoice !== undefined" class="personData">
      <slot></slot>
      <label>{{ contractor.lastName + " " + contractor.firstName }}</label>
      <input v-if="contractor.multisport" type="checkbox" id="multisport" disabled checked>
      <label v-if="contractor.multisport" for="multisport" style="font-size: small;">MultiSport</label>
      <font-awesome-icon class="icon clock" icon="clock"/>
      <invoice_input class="input1" :placeholder="`${this.contractor.invoice.hours ? this.contractor.invoice.hours : ''} h`" :id="contractor.id" :selectedMonth="selectedMonth" 
                      :contractorData="contractor" :dataProperty="dataProperty.hours"></invoice_input>
      <font-awesome-icon class="icon euro" style="margin-left: 0.5em" icon="euro-sign"/>
      <invoice_input class="input" :placeholder="`${this.contractor.invoice.rate ? this.contractor.invoice.rate : ''} €/hr`"
                      :id="contractor.id" 
                      :selectedMonth="selectedMonth" :contractorData="contractor" :dataProperty="dataProperty.rate"></invoice_input>
      <invoice_input class="input" :placeholder="`${this.contractor.invoice.active ? this.contractor.invoice.active : ''} %`"
                    :id="contractor.id"
                    :selectedMonth="selectedMonth" :contractorData="contractor" :dataProperty="dataProperty.active"></invoice_input>
      <invoice_input class="input" :placeholder="`${this.contractor.invoice.pasive ? this.contractor.invoice.pasive : ''} %`"
                    :id="contractor.id"
                    :selectedMonth="selectedMonth" :contractorData="contractor" :dataProperty="dataProperty.pasive"></invoice_input>
      <invoice_input class="input" :placeholder="`${this.contractor.invoice.discount ? this.contractor.invoice.discount : ''} €`"
                    :id="contractor.id"
                    :selectedMonth="selectedMonth" :contractorData="contractor" :dataProperty="dataProperty.discount"></invoice_input>
      <invoice_input class="input" :placeholder="`${this.contractor.invoice.reward ? this.contractor.invoice.reward : ''} €`"
                    :id="contractor.id"
                    :selectedMonth="selectedMonth" :contractorData="contractor" :dataProperty="dataProperty.reward"></invoice_input>
      <div class="summarize">{{summarize | price}}</div>
      <hr>
    </div>
    <div v-else class="personData-deactivated">
      <slot></slot>
      <label>{{ contractor.lastName + " " + contractor.firstName }}</label>
      <font-awesome-icon class="icon clock" icon="clock"/>
      <invoice_input class="input1" :placeholder="`${this.contractor.invoice.hours ? this.contractor.invoice.hours : ''} h`"
                    :id="contractor.id" :selectedMonth="selectedMonth" :contractorData="contractor" :dataProperty="dataProperty.hours" :disabled="disabled"></invoice_input>
      <font-awesome-icon class="icon euro" style="margin-left: 0.5em" icon="euro-sign"/>
      <invoice_input class="input" :placeholder="`${this.contractor.invoice.rate ? this.contractor.invoice.rate : ''} €/hr`"
                      :id="contractor.id" 
                      :selectedMonth="selectedMonth" :contractorData="contractor" :dataProperty="dataProperty.rate" :disabled="disabled"></invoice_input>
      <invoice_input class="input" :placeholder="`${this.contractor.invoice.active ? this.contractor.invoice.active : ''} %`"
                    :id="contractor.id"
                    :selectedMonth="selectedMonth" :contractorData="contractor" :dataProperty="dataProperty.active" :disabled="disabled"></invoice_input>
      <invoice_input class="input" :placeholder="`${this.contractor.invoice.pasive ? this.contractor.invoice.pasive : ''} %`"
                    :id="contractor.id"
                    :selectedMonth="selectedMonth" :contractorData="contractor" :dataProperty="dataProperty.pasive" :disabled="disabled"></invoice_input>
      <invoice_input class="input" :placeholder="`${this.contractor.invoice.discount ? this.contractor.invoice.discount : ''} €`"
                    :id="contractor.id"
                    :selectedMonth="selectedMonth" :contractorData="contractor" :dataProperty="dataProperty.discount" :disabled="disabled"></invoice_input>
      <invoice_input class="input" :placeholder="`${this.contractor.invoice.reward ? this.contractor.invoice.reward : ''} €`"
                    :id="contractor.id"
                    :selectedMonth="selectedMonth" :contractorData="contractor" :dataProperty="dataProperty.reward" :disabled="disabled"></invoice_input>
      <div class="summarize">{{summarize | price}}</div>
      <hr>
    </div>
  </div>
</template>

<script>
import invoice_input from "../../components/invoice_input";

export default {
  name: "invoice_item",
  components: {
    invoice_input
  },
  data() {
    return {
      disabled: true,
      selectedInvoice: {
        time: undefined,
        rate: undefined,
        active: undefined,
        pasive: undefined,
        discount: undefined,
        bonus: undefined,
      },
      updated: false,
      emptyRates: {
        time: null,
        hodinovka: null,
        aktiva: null,
        pasiva: null,
        zlava: null,
        extra: null,
      },
      emptyHours: {
        time: null,
        value: null
      },
      dataProperty: {
        hours: 'hours',
        rate: 'rate',
        active: 'active',
        pasive: 'pasive',
        discount: 'discount',
        reward: 'reward'
      }
    }
  },
  methods: {
    getItem(month, array) {
      if (month === null || month.value === null || !array || array.length === 0) {
        return null;
      }
      return array.find(item => new Date(item.time).getFullYear() === new Date(month.value * 1000).getFullYear() && new Date(item.time).getMonth() === new Date(month.value * 1000).getMonth());
    },
  },
  computed: {
    summarize() {
      let hours = parseFloat(this.contractor.invoice.hours);
      let rate = parseFloat(this.contractor.invoice.rate);
      let discount = parseFloat(this.contractor.invoice.discount);
      let reward = parseFloat(this.contractor.invoice.reward);
      
      return rate && hours ? (((hours * rate) - discount) + reward) : 0;
    },
  },
  props: ['selectedMonth', 'contractor'],
}
</script>

<style lang="scss">
@import "../../assets/colors.scss";

.summarize {
  width: 100px;
  text-align: right;
}

@media only screen and (max-width: 600px) {
  .personData {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    padding: 1em;
    margin-top: 0.5em;
    background: $light-brown;
    color: $company-primary;
    border-radius: 0.75em;
    transition: all 0.5s ease-in-out;

    .input1 {
      margin-right: 2em !important;
    }

    .input {
      margin-right: 2em !important;
      margin-left: 0.5em !important;
    }

    .cue{
      width: 5em;
      display: inline-flex;
      align-items: center;
      height: 3em;
    }

    label {
      margin: auto;
      width: 90%;
      font-size: 1.1em;
      text-align: center;
    }

    .clock {
      height: 3em;
      justify-self: center;
      margin-right: 4.5em;
    }


    .euro {
      display: none;
    }

    .clock {
      margin-top: 0.8em;
    }

    hr {
      display: none;
    }
  }
}

@media (min-width: 601px) {
  .personData {
    height: 2.5em;
    display: flex;
    flex-direction: row;
    padding: 0.5em 1em;
    background: $light-brown;
    color: $company-primary;
    align-items: center;
    transition: all 0.5s ease-in-out;
    position: relative;

    &:first-child {
      border-top-left-radius: 0.75em;
      border-top-right-radius: 0.75em;
    }

    &:last-child {
      border-bottom-left-radius: 0.75em;
      border-bottom-right-radius: 0.75em;

      hr {
        display: none;
      }
    }

    &:hover {
      background: $company-secondary;

      .invoice_input {
        border: 3px solid $company-accent !important;
        background: $gray;
      }

      .editing {
        border: 3px solid $company-primary !important;
      }
    }

    label {
      flex: 1;
      margin-top: auto;
      margin-bottom: auto;
    }

    .cue {
      display: none;
    }
  }

  .personData-deactivated {
    height: 2.5em;
    display: flex;
    flex-direction: row;
    padding: 0.5em 1em;
    background: #B0BEC5;
    color: $company-primary;
    align-items: center;
    transition: all 0.5s ease-in-out;
    position: relative;

    &:first-child {
      border-top-left-radius: 0.75em;
      border-top-right-radius: 0.75em;
    }

    &:last-child {
      border-bottom-left-radius: 0.75em;
      border-bottom-right-radius: 0.75em;

      hr {
        display: none;
      }
    }

    label {
      flex: 1;
      margin-top: auto;
      margin-bottom: auto;
    }

    .cue {
      display: none;
    }
  }
}

.edit {
  background-color: $hover-gray;
  font-size: 0.7em;
  cursor: pointer;
  padding: 0.5em 0.5em;
  display: inline-block;
  border: none;
  outline: none !important;
  border-radius: 0.5em;
  box-sizing: border-box;
  font-weight: bold;
  height: 100%;
  min-width: 2em;
  max-width: 7em;
  margin: 0 0.5em;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: $company-accent;
  }
}

.personData {

  hr {
    position: absolute;
    bottom: -0.54em;
    border: 1px solid $gray;
    width: 98%;
    left: 0;
    margin-left: 2%;
  }
}


.editing {
  border: 3px solid $company-primary !important;
}

.icon {
  margin-right: 0.25em;
  color: $company-primary;
}


</style>
